@use "../../zr-theme/zr-variables.scss" as *;
@use '../../zr-theme/functions/fonts' as f;
@use "../../zr-css-icon/zr-css-icon.scss" as i;

// component name
$component: 'zr-loyalty-points-badge';

:host {
    display: inline-block;
    width: max-content;
}

.#{$component} {
    @include i.get-icon-left(loyalty-hearth);

    background-color: var(--ci-loyalty-beige, #F6E5D2);
    padding: 12px;
    display: flex;
    width: auto;
    align-items: center;
    font-size: f.calc-em(16);
    font-weight: 700;
    color: var(--ci-loyalty-blue, #123459);

    &::before {
        height: 20px;
        width: 20px;
        margin-right: 4px;
        background-color: var(--ci-loyalty-blue, #123459);
    }
}
